import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const SendOtp = async (EmailId) => {
    //debugger
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/SendOtp?EmailId=${EmailId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ForgotPassword_ValidateOtp = async (EmailId, Otp) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/ForgotPassword_ValidateOtp?EmailId=${EmailId}&Otp=${Otp}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const ForgotPasswordUpdate = async (req_data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/ForgotPasswordUpdate`, JSON.stringify(req_data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}